import * as utils from '@/libs/utils'
import http from '@/libs/http'
import { storage } from '../../libs/tools'

export default {
  state: {
    token: utils.getToken(),
    userInfo: null
  },
  getters: {
    userInfo: state => {
      return state.userInfo ? state.userInfo : storage.getItem('userInfo')
    }
  },
  mutations: {
    setToken (state, token) {
      state.token = token
      utils.setToken(token)
    },
    setUserInfo (state, userInfo) {
      state.userInfo = userInfo
      storage.setItem('userInfo', userInfo)
    }
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { userName, password }) {
      userName = userName.trim()
      return new Promise((resolve, reject) => {
        http.login({
          userName,
          password
        }).then(res => {
          const data = res.data
          const { userInfo } = data
          commit('setUserInfo', userInfo)
          commit('setToken', data.token)
          commit('setMenuList', data.menuList || [])
          commit('setShowErrorStatus', data.menuList || [])
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        http.logOut().then(() => {
          commit('setToken', '')
          storage.clearAll()
          resolve()
        }).catch(err => {
          reject(err)
        })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setToken', '')
        // commit('setAccess', [])
        // storage.clearAll()
        // resolve()
      })
    }
  }
}
